import { useState } from "react";
import { Button, Modal } from "antd";
import { PaymentLinkProvider } from "../../../context/PaymentLinkContext";
import dayjs from "dayjs";
import "../utils/index.css";
import { Row, Col } from "reactstrap";
import BusinessSelect from "../components/BusinessSelect";
import { LinkOutlined } from "@ant-design/icons";
import CampaignLinkTable from "../components/CampaignLinkTable";
import CampaignLinkForm from "../components/CampaignLinkForm";
import { createNewPaymentLink } from "../service/api";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";

const SchoolFees = () => {
  document.title = `School Feez | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  // Variables d'état
  const queryClient = useQueryClient();
  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));

  const merchantId = currentUser?.user?.id || currentUser?.user?.merchantId;
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const createCampaignLinkMutation = useMutation(createNewPaymentLink);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSubmit = (data) => {
    createCampaignLinkMutation.mutate(
      {
        queryKey: [
          null,
          selectedBusiness?.apiKey,
          selectedBusiness?.apiToken,
          currentUser.token,
        ],
        requestData: data,
      },
      {
        onSuccess: (response) => {
          toast.success("Lien de campagne créé avec succès.");
          queryClient.invalidateQueries({
            queryKey: ["school-payment-links"],
          });
        },
        onError: (error) => {
          toast.error("Erreur lors de la création.");
        },
      },
    );
    setIsModalOpen(false);
  };

  return (
    <PaymentLinkProvider>
      <Row>
        <Col>
          <div className="gap-4 w-100 page-container">
            <div className="page-header">
              <h2 className="title-page mb-3">
                Lien de Campagne <span className="fw-bold">EduPax</span>
              </h2>
              <div className="d-flex justify-content-between col-12 my-4">
                <BusinessSelect
                  merchantId={merchantId}
                  token={currentUser.token}
                  setSelectedBusiness={setSelectedBusiness}
                />
                <Button
                  disabled={!selectedBusiness}
                  onClick={() => setIsModalOpen(true)}
                  className="d-inline-flex align-items-center justify-content-center table-btn"
                >
                  <LinkOutlined />
                  <span>Créer un lien de campagne</span>
                </Button>
              </div>
            </div>
            <div className="mt-3">
              <CampaignLinkTable
                business={selectedBusiness}
                token={currentUser.token}
                merchantId={merchantId}
              />
            </div>
            {/* Modal to create link */}
            <Modal
              open={isModalOpen}
              onCancel={handleCancel}
              footer={false}
              width={550}
            >
              <div className="container px-2 px-md-5 py-2">
                <CampaignLinkForm
                  closeModal={handleCancel}
                  onSubmit={handleSubmit}
                />
              </div>
            </Modal>
          </div>
        </Col>
      </Row>
    </PaymentLinkProvider>
  );
};
export default SchoolFees;

// {
//   "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJwYXBlZGlhYmVsLnNlY2tAc3lzdGFsaW5rLmZyIiwiaXNzIjoiYXV0aC1zZXJ2aWNlIiwidXNlcklkIjoyMiwicm9sZXMiOlsiTUVSQ0hBTlQiXSwiaWF0IjoxNzc0NTMzNDY4LCJleHAiOjE3NzQ1MzUyNjh9.6k8wnSGP5rDxPh5uaW_PTgjzMebUk2LqBNxYZT5iV6gT_0hyd9mGN-SXOor3ZpUpEndDBx2RBS9YNcCSTQyliQ",
//   "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJwYXBlZGlhYmVsLnNlY2tAc3lzdGFsaW5rLmZyIiwiaWF0IjoxNzc0NTMzNDY4LCJleHAiOjE3NzQ2MTk4NjgsImp0aSI6ImJlZGI5NTUyLWQxNmMtNDA0Mi05NzdlLTdkNmZhNzlkYzIyYSJ9.vNuMXyqIbjN1EAe0_Ax8YtOOuWij18O7n0DwfhfjoIVmC8Hx-lR3a3D-kEFdS3rpIbqEJaSXjoRnop5JyQ6zdg",
//   "firstname": "SECK",
//   "lastname": "Pape",
//   "username": "merchant_user_atGoj9",
//   "email": "papediabel.seck@systalink.fr",
//   "kycVerified": true,
//   "roles": "MERCHANT",
//   "userId": 22,
//   "user": {
//       "id": 22,
//       "firstName": "SECK",
//       "lastName": "Pape",
//       "username": "merchant_user_atGoj9",
//       "email": "papediabel.seck@systalink.fr",
//       "adresse": "Senegal",
//       "phoneNumber": "string",
//       "kycVerified": true,
//       "active": true,
//       "identityNumber": null,
//       "createdDate": "2024-12-26T08:46:38",
//       "twoFaSecret": null,
//       "twoFaEnabled": false,
//       "newMerchant": false
//   },
//   "isAdmin": false,
//   "twoFaEnabled": false
// }

// {
//   "success": true,
//   "message": "Connexion réussie.",
//   "data": {
//       "token": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhbHVuZWZhbGxAZ21haWwuY29tIiwiaXNzIjoiYXV0aC1zZXJ2aWNlIiwidXNlcklkIjo1NCwicm9sZXMiOlsiQ09MTEFCT1JBVE9SIl0sImlhdCI6MTc3NDUzMjE5NiwiZXhwIjoxNzc0NTMzOTk2fQ.hSHUWsK8GVR3oEQ6V-Zr6dZIpplG_zJ6z1g3c15g3w8CZjicaLPvfJMTeMCDJImOs10VlDUq1qSZB5My1b_aRw",
//       "refreshToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhbHVuZWZhbGxAZ21haWwuY29tIiwiaWF0IjoxNzc0NTMyMTk2LCJleHAiOjE3NzQ2MTg1OTYsImp0aSI6IjhhN2RjMzI0LWUwZGQtNGM0Mi05NDc3LTI5MDQ5MDc4NTFmYSJ9.FhHXBn6lx8B3J-TH-CAuqqLqwaR54OzUNpo_Ioaqs5Ifu2T55knp8FiqNYBhUyDZlMw28wdQ1mo24JFwNU6mNg",
//       "role": "COLLABORATOR",
//       "user": {
//           "fullName": "Alune Fall",
//           "email": "alunefall@gmail.com",
//           "username": "collab_user_2a4185",
//           "password": null,
//           "role": "COLLABORATOR",
//           "merchantId": 54,
//           "twoFaSecret": null,
//           "twoFaEnabled": false,
//           "permissions": [
//               "TRANSFER",
//               "MANAGE_COLLABORATORS",
//               "VIEW_DASHBOARD",
//               "VIEW_TRANSACTIONS",
//               "CREATE_BUSINESS",
//               "REQUEST_PAYOUT",
//               "VIEW_PAYOUT",
//               "VIEW_TRANSFER",
//               "CREATE_PAYMENT_LINK"
//           ]
//       }
//   }
// }
